<template>
  <div class="panel login-panel">
    <div class="header-content">
      <a href="https://quickreceipts.co"><img src="@/assets/img/logo-auth.png" alt="" /></a>
    </div>
    <div class="content-container">
      <card class="login-panel-content">
        <p class="text-center"><strong>Sign In</strong></p>
        <form @submit.prevent>
          <div class="form-group">
            <fg-input type="text"
                      placeholder="Email"
                      v-model="form.email">
            </fg-input>
          </div>
          <div class="form-group">
            <fg-input type="password"
                      placeholder="Password"
                      v-model="form.password">
            </fg-input>
          </div>
          <p-button nativeType="submit" type="success" block @click.native="onSubmit" :disabled="hasError() || loading" :loading="loading">SIGN IN</p-button>
          <p v-show="error" class="error text-danger">{{error}}</p>

          <hr/>

          <p-button class="btn-with-github" block @click.native="onSubmitGithub" :disabled="loading">
            <img src="@/assets/img/providers/github.png" alt="" /> Sign in with GitHub
          </p-button>
          <p-button class="btn-with-google" block @click.native="onSubmitGoogle" :disabled="loading">
            <img src="@/assets/img/providers/google.png" alt="" /> Sign in with Google
          </p-button>
        </form>
      </card>
    </div>
    <div class="footer-content">
      <p-button simple @click.native="onForgotPassword">Forgot Password?</p-button>
    </div>
    <div class="footer-content" style="margin-top: 2rem;">
      <span>Not a member yet?</span>&nbsp;<strong><router-link to="/signup">Sign up</router-link></strong>
    </div>

    <div class="copyright">&copy; 2019 <strong>QUICKRECEIPTS</strong> ALL RIGHTS RESERVED</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: {
        email: '',
        password: '',
        error: {
          email: true,
          password: true
        }
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.validate()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'loading',
    ])
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      if (!this.hasError()) {
        const {error, ...payload} = this.form
        this.$store.dispatch('userSignIn', payload)
      }
    },
    onForgotPassword(e) {
      this.$router.push('/reset-password')
    },
    validate() {
      this.form.error.email = !this.form.email
      this.form.error.password = !this.form.password
    },
    hasError() {
      return Object.keys(this.form.error).some((key) => this.form.error[key])
    },
    onSubmitGithub() {
      this.$store.dispatch('userSignUpWithGithub')
    },
    onSubmitGoogle() {
      this.$store.dispatch('userSignUpWithGoogle')
    }
  }
}
</script>
<style lang="scss">
.login-panel {
  min-width: 360px;
  .header-content {
    text-align: center;
    margin-bottom: 1rem;
  }
  .login-panel-content {
    padding: 20px 20px 0;
    box-shadow: 0 2px 6px rgba(204, 197, 185, 0.5);
    form {
      max-width: 300px;
      margin: 30px auto;
    }
    .btn {
      text-transform: initial;
      height: 40px;
      box-shadow: 0 0 4px 2px #dedede;
      // display: flex;
      // justify-content: space-evenly;
      img {
        margin-right: 25px;
      }
    }
  }
  .footer-content {
    text-align: center;
  }
  .btn-with-github {
    background: linear-gradient(to bottom, #444, #000);
    border: 0 none;
    transition: none;
    &:hover {
      background: #000;
    }
  }
  .btn-with-google {
    background: linear-gradient(to bottom, #fff, #f8f8f8);
    color: #000;
    border: 0 none;
    transition: none;
    &:hover {
      background: #ececec;
    }
  }
  .copyright {
    font-size: 10px;
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>